"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userIsAnonymous = exports.getUserId = exports.getUserEmail = exports.getCookieValue = exports.ANONYMOUS_USER_ID = exports.ANONYMOUS_USER = void 0;
const token_1 = require("./token");
exports.ANONYMOUS_USER = "Anonymous";
exports.ANONYMOUS_USER_ID = "000000000000000000000000000000000000";
function getCookieValue(cookieName) {
    var _a, _b;
    return (_b = (_a = document.cookie) === null || _a === void 0 ? void 0 : _a.split(`${cookieName}=`)[1]) === null || _b === void 0 ? void 0 : _b.split(";")[0];
}
exports.getCookieValue = getCookieValue;
const getUserEmail = () => {
    var _a;
    const userClaims = (0, token_1.getIdTokenUserClaims)();
    return ((_a = userClaims === null || userClaims === void 0 ? void 0 : userClaims.email) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || exports.ANONYMOUS_USER;
};
exports.getUserEmail = getUserEmail;
const getUserId = () => {
    var _a, _b;
    const userClaims = (0, token_1.getIdTokenUserClaims)();
    return ((_b = (_a = userClaims === null || userClaims === void 0 ? void 0 : userClaims.mdcUserId) === null || _a === void 0 ? void 0 : _a.toString()) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || exports.ANONYMOUS_USER_ID;
};
exports.getUserId = getUserId;
const userIsAnonymous = () => (0, exports.getUserEmail)() === exports.ANONYMOUS_USER;
exports.userIsAnonymous = userIsAnonymous;
//# sourceMappingURL=utils.js.map